export const salesData = [
  {
    name: "Orders Monthly",
    amount: "48,548",
  },
  {
    name: "Orders Weekly",
    amount: "6,478",
  },
  {
    name: "Average Revenue",
    amount: "$210,213",
  },
  {
    name: "Total Revenue",
    amount: "$692,874",
  },
  {
    name: "Total Orders",
    amount: "9,223",
  },
  {
    name: "Past Orders",
    amount: "8,543",
  },
];

export const adminDataItems = [
    {
      name: "Total Single Stock",
      amount: 2800,
      fill: "#3BD2A2",
    },
    {
      name: "Total Bulk Stock",
      amount: 2400,
      fill: "#F39711",
    },
    {
        name: "Total Jewelry Stock",
        amount: 5100,
        fill: "#FF0000",
      },
  ];


export const dataItems = [
  {
    name: "Average Revenue",
    amount: 4000,
    fill: "#0b191b",
  },
  {
    name: "Total Revenue",
    amount: 3200,
    fill: "#2EB5C9",
  },
  {
    name: "Average Orders",
    amount: 2800,
    fill: "#3BD2A2",
  },
  {
    name: "Total Orders",
    amount: 2400,
    fill: "#F39711",
  },
];

export const dataLine = [
    { name: "Jan", A: 4000, B: 2400, C: 2400, D: 2420 },
    { name: "Feb", A: 3000, B: 1398, C: 2210, D: 2250 },
    { name: "Mar", A: 2000, B: 9800, C: 2290, D: 2240 },
    { name: "Apr", A: 2780, B: 3908, C: 2000, D: 2030 },
    { name: "May", A: 1890, B: 4800, C: 2181, D: 2141 },
    { name: "Jun", A: 2390, B: 3800, C: 2500, D: 2550 },
    { name: "Jul", A: 3490, B: 4300, C: 2100, D: 2130 },
  ];
export const data = [
  {
    name: "Page A",
    month: "Jan",
    sale: 1200,
  },
  {
    name: "Page B",
    month: "Feb",
    sale: 1600,
  },
  {
    name: "Page C",
    month: "Mar",
    sale: 3000,
  },
  {
    name: "Page D",
    month: "Apr",
    sale: 3600,
  },
  {
    name: "Page E",
    month: "May",
    sale: 4800,
  },
  {
    name: "Page F",
    month: "Jun",
    sale: 4200,
  },
  {
    name: "Page G",
    month: "Jul",
    sale: 4600,
  },
  {
    name: "Page C",
    month: "Aug",
    sale: 3800,
  },
  {
    name: "Page D",
    month: "Sep",
    sale: 5200,
  },
  {
    name: "Page E",
    month: "Oct",
    sale: 5800,
  },
  {
    name: "Page F",
    month: "Nov",
    sale: 6800,
  },
  {
    name: "Page G",
    month: "Dec",
    sale: 7200,
  },
];

export const AdminDataDetails = [
  {
    name: "Total Sales",
    month: "Jan",
    uv: 4000,
    pv: 2400,
  },
  {
    name: "Total Memo",
    month: "Feb",
    uv: 3000,
    pv: 1398,
  },
  {
    name: "Total Purchase",
    month: "Mar",
    uv: 2000,
    pv: 9800,
  },
  {
    name: "Total consignment",
    month: "Apr",
    uv: 2780,
    pv: 3908,
  },
];
export const menuItems = [
  {
    title: "Full report",
    slug: "report",
  },
  {
    title: "Subscribe",
    slug: "subscribe",
  },
];
